import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Api } from '@carrier/utils/Api';

export const fetchAdmins = createAsyncThunk(
  'admins/fetchAdmins',
  async (carrierId, { rejectWithValue }) => {
    try {
      const { data } = await Api.loadCarrierAdmins({ carrier_id: carrierId });

      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch admins');
    }
  }
);

export const deleteAdmin = createAsyncThunk(
  'admins/deleteAdmin',
  async (adminId, { rejectWithValue }) => {
    try {
      await Api.deleteCarrierAdmin(adminId);
      return adminId;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to delete admin');
    }
  }
);

const initialState = {
  admins: [],
  loading: false,
  error: null,
  currentCarrierId: null
};

const adminSlice = createSlice({
  name: 'admins',
  initialState,
  reducers: {
    setCurrentCarrier: (state, action) => {
      state.currentCarrierId = action.payload;
    },
    resetAdmins: () => initialState
  },
  extraReducers: builder => {
    builder
      // Fetch Admins
      .addCase(fetchAdmins.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdmins.fulfilled, (state, action) => {
        state.admins = action.payload;
        state.loading = false;
      })
      .addCase(fetchAdmins.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete Admin
      .addCase(deleteAdmin.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAdmin.fulfilled, (state, action) => {
        state.admins = state.admins.filter(admin => admin.id !== action.payload);
        state.loading = false;
      })
      .addCase(deleteAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setCurrentCarrier, resetAdmins } = adminSlice.actions;
export default adminSlice.reducer;
